import { Link } from 'react-router-dom'

import { Bodytext, Button, Card, Heading, InfoNote } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyledHeading = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
  margin-top: 30px;
  margin-bottom: 40px;
  text-align: center;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 0px;
    margin-bottom: 30px;
  }
`

export const ThemeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 80px;
  align-items: center;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
    width: 100%;
  }
`

export const ThemeCardButton = styled.button<{ isActive: boolean; hasBadge?: boolean }>`
  max-width: 340px;
  display: flex;
  flex-direction: ${props => (props.hasBadge ? 'column' : 'row')};
  align-items: ${props => (props.hasBadge ? 'none' : 'center')};
  padding-top: ${props => (props.hasBadge ? '0px' : '10px')};
  cursor: pointer;
  background: ${style(theme => theme.colors.white)};
  border-radius: ${style(theme => theme.borderRadius.large)};
  box-shadow: ${props => props.isActive && style(theme => theme.shadows.lgMedium)};
  border: ${props => (!props.isActive ? '1px solid #F5F5F5' : '1px solid white')};
  &:not(:last-child) {
    margin-bottom: 20px;
  }

  @media screen and (min-width: ${style(theme => theme.breakpoints.sm + 1)}px) {
    &:hover {
      box-shadow: 0 0 0 1px #cccfcf;
    }
  }
`

export const ThemeCardTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 16px 20px 14px;
  text-align: left;
`

export const CoreIconContainer = styled.div`
  margin-bottom: 9px;
  margin-right: 14px;
`

export const SustainableIconContainer = styled.div`
  margin-bottom: 9px;
  margin-left: 16px;
`

export const StyledButton = styled(Button)`
  width: 220px;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

export const StyledBody = styled(Bodytext)`
  margin-top: 2px;
  width: 100%;
  display: flex;
`

export const StyledInfoNote = styled(InfoNote)`
  margin-top: 15px;
  width: 100%;

  svg {
    position: relative;
    top: -1px;
  }
`

export const StyledSustainableMainBody = styled.div`
  display: flex;
  align-items: center;
`

export const StyledMobileCard = styled(Card)`
  &&& {
    box-shadow: none;
    border-radius: none;
  }
`

export const InfoNoteLink = styled(Link)`
  text-decoration: none;
`

export const SpinnerContainer = styled.div`
  height: calc(50vh - 40px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
